import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const H_SERIES_IMAGE =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_renewable-ag-infra/artifacts/788ebcbbb4670a35_czzogy5o_6a747085-998c-4532-be30-2dcfd679b4f7.png";

export const ProductsHero = () => {
  const navigate = useNavigate();

  return (
    <section
      data-testid="products-hero-section"
      className="bg-baseLight px-6 pt-[130px] pb-0 sm:pt-[150px] sm:pb-[40px] lg:px-12 lg:pt-[190px] lg:pb-[70px]"
    >
      <div className="lg:mx-auto lg:max-w-[1280px]">
        <div className="grid grid-cols-1 items-center gap-0 lg:grid-cols-[56.25%_32px_1fr] lg:gap-0">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span data-testid="products-hero-eyebrow" className="text-sm font-medium text-teal">
              PRODUCTS
            </span>
            <h1
              data-testid="products-hero-headline"
              className="mt-3 font-heading text-[34px] font-semibold leading-[1.1] text-ink sm:text-[46px] lg:text-[55px]"
            >
              One platform. Four
              <br className="hidden lg:block" />
              power classes
            </h1>
            <p
              data-testid="products-hero-text"
              className="mt-[32px] lg:mt-6 max-w-xl text-[15px] leading-relaxed text-inkSoft"
            >
              A modular hybrid energy platform designed for agricultural and rural operations
              — combining short-duration battery response with configurable long-duration
              hydrogen energy storage.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-x-7 gap-y-4">
              <button
                type="button"
                data-testid="products-hero-cta-primary"
                onClick={() => navigate("/#contact")}
                className="inline-flex h-11 items-center bg-teal text-white text-sm font-medium rounded-full px-6 hover:bg-tealHover transition-all duration-300 hover:-translate-y-0.5"
              >
                Request an Energy Assessment
              </button>
              <Link
                to="/technology"
                data-testid="products-hero-cta-secondary"
                className="group inline-flex items-center gap-1.5 text-sm text-inkSoft hover:text-teal transition-colors duration-300"
              >
                <span className="underline decoration-borderSubtle group-hover:decoration-teal/60 transition-colors duration-300">
                  Explore the Technology
                </span>
                <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-0.5" />
              </Link>
            </div>
          </motion.div>

          <div className="hidden lg:block" aria-hidden="true" />

          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="-mt-[10px] -mb-[10px] sm:mt-0 sm:mb-0 lg:mt-0 lg:mb-0"
          >
            <div data-testid="products-hero-visual" className="aspect-[3/2] w-full">
              <img
                src={H_SERIES_IMAGE}
                alt="Off-Grid Hydrogen H-series platform — H25, H60, H125 and H250 reference classes"
                className="h-full w-full object-contain"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
